/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

const AccountInvites = require("../models/contacts/AccountInvites.js");
const ActiveGroupFormSubmission = require("../models/forms/ActiveGroupFormSubmission.js");
const ActiveOwnFormSubmission = require("../models/forms/ActiveOwnFormSubmission.js");
const ActiveOwnFormPrepopulate = require("../models/forms/ActiveOwnFormPrepopulate.js");
const AllContacts = require("../models/contacts/AllContacts.js");
const AudioOutputSelector = require("../models/call/AudioOutputSelector.js");
const AutoReply = require("../models/messages/AutoReply.js");
const Availability = require("../models/available/Availability.js");
const AvailabilityNotifier = require("../models/available/AvailabilityNotifier.js");
const Backbutton = require("../models/Backbutton");
const BackgroundNotifications = require("../models/notifications/BackgroundNotifications.js");
const BackgroundSocket = require("../models/available/BackgroundSocket.js");
const BannerNotice = require("../models/notifications/BannerNotice.js");
const Banners = require("../models/notifications/Banners.js");
const Blocking = require("../models/blocking/Blocking.js");
const Bluetooth = require("../models/bluetooth/Bluetooth.js");
const BluetoothOnOff = require("../models/bluetooth/BluetoothOnOff.js");
const BluetoothScanner = require("../models/bluetooth/BluetoothScanner.js");
const CallFocuser = require("../models/call/CallFocuser.js");
const Calling = require("../models/call/Calling.js");
const CallInputSwitcher = require("../models/desktop/CallInputSwitcher.js");
const CallMagnifier = require("../models/call/CallMagnifier.js");
const CallRedirector = require("../models/call/CallRedirector.js");
const ConferenceInviter = require("../models/call/ConferenceInviter.js");
const ContactList = require("../models/contacts/ContactList.js");
const ContactProfile = require("../models/contacts/ContactProfile.js");
const ContactRequests = require("../models/contacts/ContactRequests.js");
const ContactSettings = require("../models/contacts/ContactSettings");
const OwnContactSettings = require("../models/contacts/OwnContactSettings");
const CoreForms = require("../models/forms/CoreForms.js");
const DevicePermissions = require("../models/available/DevicePermissions.js");
const DeviceGlucoseTNG = require("../models/myhealth/DeviceGlucoseTNG.js");
const DeviceActivity = require("../models/myhealth/DeviceActivity.js");
const DeviceTemperature = require("../models/myhealth/DeviceTemperature.js");
const Desktop = require("../models/main/Desktop.js");
const FallInvalidator = require("../models/notifications/FallInvalidator.js");
const FileViewer = require("../models/FileViewer.js");
const FocusState = require("../models/available/FocusState.js");
const FormSources = require("../models/forms/FormSources.js");
const GroupFormList = require("../models/forms/GroupFormList.js");
const GroupFormSubmissions = require("../models/forms/GroupFormSubmissions.js");
const Homepage = require("../models/desktop/Homepage.js");
const IncomingContactRequests = require("../models/contacts/IncomingContactRequests.js");
const IncomingManagementRequests = require("../models/manage/IncomingManagementRequests.js");
const IncomingOrgGroupRequests = require("../models/desktop/IncomingOrgGroupRequests.js");
const InputOptions = require("../models/desktop/InputOptions.js");
const Loading = require("../models/desktop/Loading.js");
const Localization = require("../models/Localization.js");
const LogoutConfirmModal = require("../models/desktop/LogoutConfirmModal.js");
const LoadChecker = require("../models/available/LoadChecker.js");
const LinkOpener = require("../models/LinkOpener.js");
const ManagedAccount = require("../models/manage/ManagedAccount.js");
const ManagedATouchAway = require("../models/manage/ManagedATouchAway.js");
const ManagedSimplified = require("../models/manage/ManagedSimplified.js");
const ManagedBracelet = require("../models/manage/ManagedBracelet.js");
const CareplanSchema = require("../models/careplan/CareplanSchema.js");
const CareplanSection = require("../models/careplan/CareplanSection.js");
const CareplanProposedChanges = require("../models/careplan/CareplanProposedChanges.js");
const OwnCareplan = require("../models/careplan/OwnCareplan.js");
const CareplanOverlay = require("../models/careplan/CareplanOverlay.js");
const ManagedCareplanExpander = require("../models/careplan/ManagedCareplanExpander.js");
const ManagedCareplanSection = require("../models/careplan/ManagedCareplanSection.js");
const ManagedCareplanSectionFlat = require("../models/careplan/ManagedCareplanSectionFlat.js");
const ManagedCareplanOverlay = require("../models/careplan/ManagedCareplanOverlay.js");
const ManagedCareplanProposedChanges = require("../models/careplan/ManagedCareplanProposedChanges.js");
const ManagedCareplanSectionEdit = require("../models/careplan/ManagedCareplanSectionEdit.js");
const ManagedCareplan = require("../models/careplan/ManagedCareplan.js");
const ManagedCareplanChangedFields = require("../models/careplan/ManagedCareplanChangedFields.js");
const ManagedCareplanChangeViewer = require("../models/careplan/ManagedCareplanChangeViewer.js");
const ManagedContactRequests = require("../models/manage/ManagedContactRequests.js");
const ManagedContacts = require("../models/manage/ManagedContacts.js");
const ManagedAccountInvites = require("../models/manage/ManagedAccountInvites.js");
const ManagedFileData = require("../models/manage/ManagedFileData.js");
const ManagedForms = require("../models/manage/ManagedForms.js");
const ManagedFormSubmissions = require("../models/manage/ManagedFormSubmissions.js");
const ManagedUserGroup = require("../models/manage/ManagedUserGroup.js");
const OrgGroup = require("../models/forms/OrgGroup.js");
const ManagedGroupFormList = require("../models/manage/ManagedGroupFormList.js");
const ManagedGroupFormOrderedList = require("../models/manage/ManagedGroupFormOrderedList.js");
const ManagedGroupFormSubmissions = require("../models/manage/ManagedGroupFormSubmissions.js");
const ManagedActiveGroupFormSubmission = require("../models/manage/ManagedActiveGroupFormSubmission.js");
const ManagedActiveGroupFormPrepopulate = require("../models/manage/ManagedActiveGroupFormPrepopulate.js");
const ManagedIncomingContactRequests = require("../models/manage/ManagedIncomingContactRequests.js");
const ManagedManagers = require("../models/manage/ManagedManagers.js");
const ManagedMetrics = require("../models/manage/ManagedMetrics.js");
const ManagedNewSectionUpdates = require("../models/manage/ManagedNewSectionUpdates.js");
const ManagedOutgoingContactRequests = require("../models/manage/ManagedOutgoingContactRequests.js");
const ManagedPendingReminders = require("../models/reminders/ManagedPendingReminders.js");
const ManagedPermissions = require("../models/manage/ManagementPermissions.js");
const ManagedReminderMaker = require("../models/reminders/ManagedReminderMaker.js");
const ManagedReminders = require("../models/reminders/ManagedReminders.js");
const ManagedReminderHistory = require("../models/reminders/ManagedReminderHistory.js");
const ManagedSectionUpdates = require("../models/manage/ManagedSectionUpdates.js");
const ManagedSectionUpdateViews = require("../models/manage/ManagedSectionsUpdateViews.js");
const ManagedUrgencyContacts = require("../models/manage/ManagedUrgencyContacts.js");
const ManagedUrgencyPotentials = require("../models/manage/ManagedUrgencyPotentials.js");
const ManagedUsers = require("../models/manage/ManagedUsers.js");
const ManagedUsersCount = require("../models/manage/ManagedUserCount.js");
const Management = require("../models/manage/Management.js");
const ManagementRequests = require("../models/manage/ManagementRequests.js");
const ManagePreferences = require("../models/manage/ManagePreferences.js");
const ManagedProfilePicture = require("../models/manage/ManagedProfilePicture.js");
const ManagedStatuses = require("../models/manage/ManagedStatuses.js");
const Messages = require("../models/messages/Messages.js");
const MyHealthDevice = require("../models/myhealth/myHealthDevice");
const Groups = require("../models/groupchat/Groups.js");
const GroupChat = require("../models/groupchat/GroupChat.js");
const GroupGroupedMessages = require("../models/groupchat/GroupedMessages.js");
const GroupedMessages = require("../models/messages/GroupedMessages.js");
const MissedVoiceCall = require("../models/call/MissedVoiceCall.js");
const MissedCall = require("../models/call/MissedCall.js");
const MissedMessages = require("../models/messages/MissedMessages.js");
const MissedNotifications = require("../models/notifications/MissedNotifications.js");
const NetworkStatus = require("../models/available/NetworkStatus.js");
const NoLogin = require("../models/nologin/NoLogin.js");
const Notifications = require("../models/notifications/Notifications.js");
const Online = require("../models/available/Online.js");
const Options = require("../models/desktop/Options.js");
const Orientation = require("../models/orientation/Orientation.js");
const OrientationLocker = require("../models/orientation/OrientationLocker.js");
const Size = require("../models/orientation/Size.js");
const OutgoingContactRequests = require("../models/contacts/OutgoingContactRequests.js");
const OutgoingManagementRequests = require("../models/manage/OutgoingManagementRequests.js");
const People = require("../models/people/People.js");
const PersonalData = require("../models/people/PersonalData.js");
const PersonalProfilePicture = require("../models/people/PersonalProfilePicture");
const Preferences = require("../models/people/Preferences.js");
const ProfileSection = require("../models/people/ProfileSection.js");
const RemotePushHandler = require("../models/notifications/RemotePushHandler.js");
const Save = require("../models/desktop/Save.js");
const ScheduleMaker = require("../models/schedules/ScheduleMaker.js");
const Schedules = require("../models/schedules/Schedules.js");
const ScreenFocus = require("../models/available/ScreenFocus.js");
const Search = require("../models/search/Search.js");
const SelfDestructor = require("../models/SelfDestructor.js");
const Sounds = require("../models/sounds/Sounds.js");
const SoundsPreferences = require("../models/sounds/SoundsPreferences.js");
const OwnFormList = require("../models/forms/OwnFormList.js");
const OwnFormSubmissions = require("../models/forms/OwnFormSubmissions.js");
const DesktopSounds = require("../models/sounds/DesktopSounds");
const LoadedSounds = require("../models/sounds/LoadedSounds");
const TrialWizard = require("../models/nologin/TrialWizard.js");
const DesktopToast = require("../models/notifications/DesktopToast.js");
const Toast = require("../models/notifications/Toast.js");
const UnreadNotifications = require("../models/notifications/UnreadNotifications.js");
const UserNotifications = require("../models/notifications/UserNotifications.js");
const ReadNotifications = require("../models/notifications/ReadNotifications");
const VideoPosition = require("../models/desktop/VideoPosition.js");
const WanderInvalidator = require("../models/notifications/WanderInvalidator.js");
const PasswordTimeout = require("../models/desktop/PasswordTimeout.js");
const Collapsibles = require("../models/desktop/Collapsibles.js");
const ManagedManagerPermissions = require("../models/manage/ManagedManagerPermissions.js");
const ManagedManagerRequests = require("../models/manage/ManagedManagerRequests.js");
const ManagedManagerOutgoingRequests = require("../models/manage/ManagedManagerOutgoingRequests.js");
const ManagedManagerInvites = require("../models/manage/ManagedManagerInvites.js");
const PermissionsEnforce = require("../models/desktop/PermissionsEnforce.js");
const SurveyInitiate = require("../models/surveys/SurveyInitiate.js");
const CallPendingList = require("../models/call/PendingCall.js");
const ManagedActivity = require("../models/manage/ManagedActivity.js");
const ManagedBloodSugar = require("../models/manage/ManagedBloodSugar.js");
const ManagedBloodPressure = require("../models/manage/ManagedBloodPressure.js");
const ManagedWeight = require("../models/manage/ManagedWeight.js");
const ManagedBloodOxygen = require("../models/manage/ManagedBloodOxygen.js");
const ManagedBodyTemperature = require("../models/manage/ManagedBodyTemperature.js");
const ManagedComment = require("../models/manage/ManagedComment.js");
const ManagedOverview = require("../models/manage/ManagedOverview.js");
const HangupReply = require("../models/messages/HangupReply");
const MessageSound = require("../models/sounds/MessageSound");
const TimezoneSetter = require("../models/people/TimezoneSetter");
const UpdateFetcher = require("../models/desktop/UpdateFetcher.js");
const ManagedResources = require("../models/resources/ManagedResources");
const ManagedResourcesList = require("../models/resources/ManagedResourcesList");
const OwnResources = require("../models/resources/OwnResources");
const OwnResourcesList = require("../models/resources/OwnResourcesList");
const UpdateRefresher = require("../models/atouchaway/UpdateRefresher.js");

// Workflow stuff
const ActiveWorkflowAction = require("../models/workflow/ActiveWorkflowAction.js");
const WorkflowActions = require("../models/workflow/WorkflowActions.js");
const WorkflowDefinitions = require("../models/workflow/WorkflowDefinitions.js");
const WorkflowInstances = require("../models/workflow/WorkflowInstances.js");
const ManagedWorkflow = require("../models/manage/ManagedWorkflow");
const ManagedOngoingWorkflow = require("../models/workflow/ManagedOngoingWorkflow");
const ManagedActionsWorkflow = require("../models/workflow/ManagedActionsWorkflow");
const ManagedCreateWorkflow = require("../models/workflow/ManagedCreateWorkflow");
const ManagedDefinitionWorkflow = require("../models/workflow/ManagedDefinitionWorkflow");
const ManagedEditiongWorkflow = require("../models/workflow/ManagedEditingWorkflow");
const ManagedHistoryWorkflow = require("../models/workflow/ManagedHistoryWorkflow");
const ActiveManagedWorkflow = require("../models/workflow/ActiveManagedWorkflow");
const WorkflowActionAutoViewerMobile = require("../models/workflow/WorkflowActionAutoViewerMobile");
const WorkflowActionPending = require("../models/workflow/WorkflowActionPending");
const WorkflowExternals = require("../models/workflow/WorkflowExternals.js");
const ManagedWorkflowExternals = require("../models/workflow/ManagedWorkflowExternals.js");

const Activity = require("../models/myhealth/Activity.js");
const BloodSugar = require("../models/myhealth/BloodSugar.js");
const Weight = require("../models/myhealth/Weight.js");
const BloodPressure = require("../models/myhealth/BloodPressure.js");
const BloodOxygen = require("../models/myhealth/BloodOxygen.js");
const BodyTemperature = require("../models/myhealth/BodyTemperature.js");
const Overview = require("../models/myhealth/Overview.js");
const Comment = require("../models/myhealth/Comment.js");
const NewReading = require("../models/myhealth/NewReading.js");
const MyHealth = require("../models/myhealth/myhealth.js");
const CustomIndicator = require("../models/myhealth/CustomIndicator.js");
const CustomIndicatorsList = require("../models/myhealth/CustomIndicatorsList.js");
const FeedbackModal = require("../models/notifications/FeedbackModal");
const MyReminders = require("../models/reminders/MyReminders.js");
const OwnReminders = require("../models/reminders/OwnReminders.js");
const OwnReminderMaker = require("../models/reminders/OwnReminderMaker.js");
const OwnReminderHistory = require("../models/reminders/OwnReminderHistory.js");
const OwnActiveReminder = require("../models/reminders/OwnActiveReminder.js");
const OwnPendingReminders = require("../models/reminders/OwnPendingReminders.js");
const SectionUpdates = require("../models/notifications/SectionUpdates.js");
const SectionUpdatesView = require("../models/notifications/SectionUpdatesView.js");
const SectionUpdatesNew = require("../models/notifications/SectionUpdatesNew.js");
const CallGroups = require("../models/callgroups/CallGroups.js");
const InCall = require("../models/people/InCall.js");
const CallGroupCalling = require("../models/callgroups/CallGroupCalling");
const CallGroupMembers = require("../models/callgroups/CallGroupMembers");
const GroupInfo = require("../models/desktop/Group.js");
const OwnStatus = require("../models/status/OwnStatus.js");
const UsersList = require("../models/organization/UsersList");
const UsersData = require("../models/organization/UsersData");
const StaffList = require("../models/organization/StaffList");
const UserCreation = require("../models/creation/UserCreation");
const UserInviteList = require("../models/organization/UsersInviteList");
const OwnDevices = require("../models/devices/OwnDevices");
const ManagedDevices = require("../models/devices/ManagedDevices");
const ManagedBluetoothScanner = require("../models/manage/ManagedBluetoothScanner");

const ActiveLiveChatGroup = require("../models/livechat/ActiveGroup");
const LiveChatGroups = require("../models/livechat/LiveChatGroups");
const ActiveLiveChatSession = require("../models/livechat/ActiveSession");
const ActiveLiveChatSessions = require("../models/livechat/ActiveSessions");
const LiveChatSessionHistory = require("../models/livechat/SessionHistory");
const LiveChatSessionPending = require("../models/livechat/PendingSessions");
const LiveChatMessages = require("../models/livechat/Messages");
const LiveChatGroupedMessages = require("../models/livechat/GroupedMessages");
const LiveChatLatestMessages = require("../models/livechat/LatestMessages");
const LiveChatMissedMessages = require("../models/livechat/MissedMessages");

const ManagedDefaultManagerPermissions = require("../models/manage/ManagedDefaultManagerPermissions");
const ManagedPresetManagerPermissions = require("../models/manage/ManagedPresetManagerPermissions");
const ManagedUrgencyPreferences = require("../models/manage/ManagedUrgencyPreferences");

const ActiveManageGroup = require("../models/organization/ActiveManageGroup");
const ManageGroups = require("../models/organization/ManageGroups");
const OwnManageGroup = require("../models/managegroup/OwnManageGroup");
const ManageManageGroupManagers = require("../models/manage/ManageManageGroupManagers");
const ActiveGroupManageGroup = require("../models/organization/ActiveGroupManageGroup");
const GroupManageGroups = require("../models/organization/GroupManageGroups");

const OrgAutoLogout = require("../models/organization/AutoLogout");
const OrgMultifactor = require("../models/organization/Multifactor");
const License = require("../models/main/License");
const PrivacyPolicy = require("../models/main/PrivacyPolicy");
const GroupSettings = require("../models/organization/GroupSettings.js");
const AccountSwitcher = require("../models/desktop/AccountSwitcher");
const ATouchAwaySettings = require("../models/atouchaway/ATouchAwaySettings");
const FinishAccount = require("../models/people/FinishAccount");
const AppRefresher = require("../models/desktop/AppRefresher");
const OwnFormOrderList = require("../models/forms/OwnFormOrderedList");

const DeviceOxygen = require("../models/myhealth/devices/bloodoxygen/DeviceOxygen");
const DeviceNonin3230 = require("../models/myhealth/devices/bloodoxygen/DeviceNonin3230");
const DeviceForaSPO2 = require("../models/myhealth/devices/bloodoxygen/DeviceForaSPO2");
const DeviceIHO2 = require("../models/myhealth/devices/bloodoxygen/DeviceIHO2");
const DeviceFollowUp = require("../models/myhealth/DeviceFollowUp");

const DeviceBloodPressure = require("../models/myhealth/devices/bloodpressure/DeviceBloodPressure");
const DeviceANDBloodPressure = require("../models/myhealth/devices/bloodpressure/DeviceA&DBloodPressure");
const DeviceIHBloodPressure = require("../models/myhealth/devices/bloodpressure/DeviceIHBloodPressure");
const DeviceBIOSBloodPressure = require("../models/myhealth/devices/bloodpressure/DeviceBIOSBloodPressure");

const DeviceWeight = require("../models/myhealth/devices/weight/DeviceWeight");
const DeviceANDWeight = require("../models/myhealth/devices/weight/DeviceA&DWeight");
const DeviceIHWeight = require("../models/myhealth/devices/weight/DeviceIHWeight");

const ManagedUsersEnd = require("../models/manage/ManagedUsersEnd");

const ManagedCustomIndicatorsList = require("../models/manage/ManagedCustomIndicatorsList");
const ManagedCustomIndicator = require("../models/manage/ManagedCustomIndicator");

const CustomOptions = require("../models/options/CustomOptions");

const PersistStorage = require("../models/persiststorage/PersistStorage");
const VersionInfo = require("../models/people/VersionInfo");

const AccountDeletion = require("../models/account/AccountDeletion");

const ManagedPatientGroups = require("../models/managegroup/ManagedPatientGroups");
const Refresh = require("../models/main/Refresh");
const Logout = require("../models/main/Logout");
const UserMetrics = require("../models/usermetrics/UserMetrics");

const create = require("./create");

const models = [
	Refresh,
	Logout,
	VersionInfo,
	PersistStorage,
	CallGroupCalling,
	CallGroupMembers,
	WorkflowDefinitions,
	WorkflowInstances,
	WorkflowActions,
	ActiveGroupFormSubmission,
	ActiveOwnFormPrepopulate,
	ActiveOwnFormSubmission,
	ActiveWorkflowAction,
	AccountInvites,
	AllContacts,
	AudioOutputSelector,
	AutoReply,
	Availability,
	AvailabilityNotifier,
	Backbutton,
	BackgroundNotifications,
	BackgroundSocket,
	BannerNotice,
	Banners,
	Blocking,
	Bluetooth,
	BluetoothOnOff,
	BluetoothScanner,
	CallFocuser,
	Calling,
	CallGroups,
	CallInputSwitcher,
	CallMagnifier,
	CallRedirector,
	CallPendingList,
	CareplanOverlay,
	CareplanProposedChanges,
	CareplanSchema,
	CareplanSection,
	Collapsibles,
	ConferenceInviter,
	ContactList,
	ContactProfile,
	ContactRequests,
	ContactSettings,
	OwnContactSettings,
	CoreForms,
	Desktop,
	DesktopSounds,
	DesktopToast,
	DevicePermissions,
	DeviceGlucoseTNG,
	DeviceActivity,
	DeviceTemperature,
	DeviceFollowUp,
	FallInvalidator,
	FileViewer,
	FocusState,
	FormSources,
	FeedbackModal,
	Groups,
	GroupChat,
	GroupFormList,
	GroupFormSubmissions,
	GroupGroupedMessages,
	GroupedMessages,
	Homepage,
	InCall,
	IncomingContactRequests,
	IncomingManagementRequests,
	IncomingOrgGroupRequests,
	InputOptions,
	LinkOpener,
	LoadedSounds,
	Loading,
	Localization,
	LogoutConfirmModal,
	ManagedAccount,
	ManagedATouchAway,
	ManagedBracelet,
	ManagedCareplan,
	ManagedCareplanChangedFields,
	ManagedCareplanChangeViewer,
	ManagedCareplanExpander,
	ManagedCareplanOverlay,
	ManagedCareplanProposedChanges,
	ManagedCareplanSection,
	ManagedCareplanSectionEdit,
	ManagedCareplanSectionFlat,
	ManagedContactRequests,
	ManagedContacts,
	ManagedAccountInvites,
	ManagedDefaultManagerPermissions,
	ManagedPresetManagerPermissions,
	ManagedFileData,
	ManagedForms,
	ManagedFormSubmissions,
	ManagedGroupFormList,
	ManagedGroupFormOrderedList,
	ManagedGroupFormSubmissions,
	ManagedActiveGroupFormSubmission,
	ManagedActiveGroupFormPrepopulate,
	ManagedIncomingContactRequests,
	ManagedManagerOutgoingRequests,
	ManagedManagerInvites,
	ManagedManagerPermissions,
	ManagedManagerRequests,
	ManagedManagers,
	ManagedMetrics,
	ManagedNewSectionUpdates,
	ManagedOutgoingContactRequests,
	ManagedPendingReminders,
	ManagedPermissions,
	ManagedProfilePicture,
	ManagedReminderMaker,
	ManagedReminders,
	ManagedReminderHistory,
	ManagedSectionUpdates,
	ManagedSectionUpdateViews,
	ManagedStatuses,
	ManagedUrgencyContacts,
	ManagedUrgencyPotentials,
	ManagedUrgencyPreferences,
	ManagedUsers,
	ManagedUsersCount,
	ManagedUsersEnd,
	Management,
	ManagementRequests,
	ManagePreferences,
	ManagedUserGroup,
	Messages,
	MissedCall,
	MissedVoiceCall,
	MissedMessages,
	MissedNotifications,
	MyHealthDevice,
	NetworkStatus,
	NoLogin,
	Notifications,
	Online,
	OrgGroup,
	Options,
	Orientation,
	OrientationLocker,
	OutgoingContactRequests,
	OutgoingManagementRequests,
	OwnCareplan,
	PasswordTimeout,
	People,
	PersonalData,
	PersonalProfilePicture,
	Preferences,
	ProfileSection,
	ReadNotifications,
	RemotePushHandler,
	Save,
	ScheduleMaker,
	Schedules,
	ScreenFocus,
	SectionUpdates,
	SectionUpdatesNew,
	SectionUpdatesView,
	Search,
	SelfDestructor,
	Size,
	OwnFormList,
	OwnFormSubmissions,
	TrialWizard,
	UnreadNotifications,
	UpdateFetcher,
	UserNotifications,
	VideoPosition,
	WanderInvalidator,
	PermissionsEnforce,
	SurveyInitiate,
	LoadChecker,
	ManagedActivity,
	ManagedBloodSugar,
	ManagedBloodPressure,
	ManagedWeight,
	ManagedOverview,
	ManagedBloodOxygen,
	ManagedBodyTemperature,
	ManagedCustomIndicatorsList,
	ManagedCustomIndicator,
	ManagedComment,
	HangupReply,
	MessageSound,
	TimezoneSetter,
	Sounds,
	SoundsPreferences,
	Toast,
	ManagedWorkflow,
	ManagedOngoingWorkflow,
	ManagedActionsWorkflow,
	ManagedCreateWorkflow,
	ManagedDefinitionWorkflow,
	ManagedEditiongWorkflow,
	ManagedHistoryWorkflow,
	ActiveManagedWorkflow,
	Activity,
	BloodSugar,
	Weight,
	BloodPressure,
	BloodOxygen,
	BodyTemperature,
	Comment,
	Overview,
	NewReading,
	MyHealth,
	CustomIndicator,
	CustomIndicatorsList,
	MyReminders,
	OwnReminders,
	OwnReminderMaker,
	OwnReminderHistory,
	OwnActiveReminder,
	OwnPendingReminders,
	OwnStatus,
	GroupInfo,
	ManagedResources,
	ManagedResourcesList,
	OwnResources,
	OwnResourcesList,
	UserInviteList,
	UsersData,
	UsersList,
	StaffList,
	UserCreation,
	OwnDevices,
	ManagedDevices,
	ManagedBluetoothScanner,
	ActiveLiveChatGroup,
	LiveChatGroups,
	ActiveLiveChatSession,
	ActiveLiveChatSessions,
	LiveChatSessionHistory,
	LiveChatSessionPending,
	LiveChatMessages,
	LiveChatGroupedMessages,
	LiveChatLatestMessages,
	LiveChatMissedMessages,
	WorkflowActionPending,
	WorkflowActionAutoViewerMobile,
	License,
	PrivacyPolicy,
	ManagedSimplified,
	WorkflowExternals,
	ManagedWorkflowExternals,
	UpdateRefresher,
	ActiveManageGroup,
	ManageGroups,
	OwnManageGroup,
	ManageManageGroupManagers,
	ActiveGroupManageGroup,
	GroupManageGroups,
	OrgAutoLogout,
	OrgMultifactor,
	GroupSettings,
	AccountSwitcher,
	ATouchAwaySettings,
	FinishAccount,
	AppRefresher,
	OwnFormOrderList,
	DeviceOxygen,
	DeviceNonin3230,
	DeviceForaSPO2,
	DeviceIHO2,
	DeviceBloodPressure,
	DeviceANDBloodPressure,
	DeviceBIOSBloodPressure,
	DeviceIHBloodPressure,
	DeviceWeight,
	DeviceANDWeight,
	DeviceIHWeight,
	CustomOptions,
	AccountDeletion,
	ManagedPatientGroups,
	UserMetrics,
];

module.exports = create(models, "desktop");
